import React from 'react';

import { AdvisorErrorPage } from '../../../../Shared/Components/AdvisorErrorPage';

interface PendingOrderErrorPageProps {
  returnToPath: string;
  assetName: string;
  assetTicker: string;
}

export const PendingOrderErrorPage: React.FC<PendingOrderErrorPageProps> = ({
  returnToPath,
  assetName,
  assetTicker,
}) => {
  return (
    <AdvisorErrorPage
      returnAddress={returnToPath}
      headerText={`Sell ${assetTicker}`}
      titleText="An order is already pending."
      bodyText={`A sell order for ${assetName} (${assetTicker}) is already in progress. Additional orders for this asset can't be submitted until the current order is complete.`}
    />
  );
};
